import Swal from "sweetalert2";
import "../ResetSenhaLogin/loginSenhaReset.scss"
import "@fortawesome/fontawesome-free/css/all.min.css";
const API_URL = process.env.REACT_APP_API_URL;











// ================= SOLICITAR CÓDIGO =================
export async function solicitarCodigo() {
 const { value: email } = await Swal.fire({
  title: "Recuperar acesso",

  html: `
    <div class="swal-recover-content">
      <div class="swal-recover-icon">
        <i class="fas fa-lock"></i>
      </div>

      <p class="swal-recover-text">
        Informe seu e-mail para receber o código de redefinição.
      </p>
    </div>
  `,

  input: "email",
  inputPlaceholder: "seuemail@empresa.com",

  inputAttributes: {
    autocapitalize: "off",
    autocomplete: "email",
    autocorrect: "off",
    spellcheck: "false"
  },

  showCancelButton: true,

  confirmButtonText: "Continuar",
  cancelButtonText: "Cancelar",

  reverseButtons: true,

  allowOutsideClick: false,
  allowEscapeKey: false,

  backdrop: "rgba(0, 5, 10, 0.82)",

  customClass: {
    popup: "swal-recover",
    title: "swal-recover-title",
    htmlContainer: "swal-recover-html",
    input: "swal-input-tech",
    actions: "swal-recover-actions",
    confirmButton: "swal-btn-primary",
    cancelButton: "swal-btn-secondary"
  },

  buttonsStyling: false,

  preConfirm: (value) => {
    const email = value?.trim();

    if (!email) {
      Swal.showValidationMessage("Digite seu e-mail.");
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email)) {
      Swal.showValidationMessage("Digite um e-mail válido.");
      return false;
    }

    return email;
  }
});

  if (!email) return;

  Swal.fire({
    html: `
    <div class="swal-loading-container">
      <div class="swal-spinner"></div>

      <div class="swal-loading-title">
        Verificando acesso
      </div>

      <div class="swal-loading-text">
        Aguarde enquanto validamos suas informações.
      </div>
    </div>
  `,
    allowOutsideClick: false,
    allowEscapeKey: false,
    showConfirmButton: false,
    backdrop: "rgba(0,0,0,0.65)",
    customClass: {
      popup: "swal-loading-tech"
    }
  });
  try {
    const response = await fetch(`${API_URL}/recuperarsenha`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email })
    });

    const data = await response.json();

    Swal.close(); // Fecha loading

    if (!response.ok) {
      return Swal.fire("Erro", data.message, "error");
    }

    await Swal.fire({
      title: "Código enviado",
      html: `
    <div class="swal-code-text">
      Enviamos um código de verificação para:
    </div>

    <div class="swal-code-email">
      ${email}
    </div>
  `,
      showConfirmButton: true,
      confirmButtonText: "Entendi",
      backdrop: "rgba(0,0,0,0.65)",
      customClass: {
        popup: "swal-code-tech",
        confirmButton: "swal-btn-primary"
      }
    });

    redefinirSenha(email);

  } catch (error) {
    Swal.close();
    Swal.fire("Erro", "Servidor indisponível", "error");
  }
}


// ================= REDEFINIR SENHA =================
async function redefinirSenha(emailPreenchido = "") {

  const { value: formValues } = await Swal.fire({
    title: "Redefinir senha",
    html: `
    <div class="swal-reset-container">

      <div class="swal-reset-info">
        Insira o código enviado para seu e-mail e defina uma nova senha segura.
      </div>

      <div class="swal-field">
        <label>E-mail</label>
        <input 
          id="swal-email"
          type="email"
          readonly
          autocomplete="off"
        />
      </div>
<div class="swal-field">
  <label>Código de verificação</label>

  <input 
    id="swal-codigo"
    type="text"
    placeholder="Digite o código recebido"
    autocomplete="one-time-code"
  />

  <div class="swal-field-error" id="swal-codigo-error"></div>
</div>
      <div class="swal-field password-field">
        <label>Nova senha</label>
        <input 
          id="swal-senha"
          type="password"
          placeholder="Crie uma nova senha"
          autocomplete="new-password"
        />
        <button type="button" class="eye-btn" data-target="swal-senha">👁</button>
      </div>

      <div class="swal-field password-field">
        <label>Confirmar senha</label>
        <input 
          id="swal-confirmar"
          type="password"
          placeholder="Repita a nova senha"
          autocomplete="new-password"
        />
        <button type="button" class="eye-btn" data-target="swal-confirmar">👁</button>
      </div>

    </div>
  `,
    showCancelButton: true,
    confirmButtonText: "Atualizar senha",
    cancelButtonText: "Cancelar",
    allowOutsideClick: false,
    allowEscapeKey: false,
    showCloseButton: true,
    backdrop: "rgba(0,0,0,0.55)",
    customClass: {
      popup: "swal-reset-popup",
      confirmButton: "swal-btn-primary",
      cancelButton: "swal-btn-secondary"
    },
    didOpen: () => {
      document.getElementById("swal-email").value = emailPreenchido;

      document.querySelectorAll(".eye-btn").forEach(btn => {
        btn.addEventListener("click", () => {
          const input = document.getElementById(btn.dataset.target);
          input.type = input.type === "password" ? "text" : "password";
        });
      });
    },
    preConfirm: async () => {
      const email = document.getElementById("swal-email").value.trim();
      const codigoInput = document.getElementById("swal-codigo");
      const codigoError = document.getElementById("swal-codigo-error");
      const novaSenha = document.getElementById("swal-senha").value.trim();
      const confirmar = document.getElementById("swal-confirmar").value.trim();

      // limpa erro anterior
      codigoInput.classList.remove("input-error");
      codigoError.textContent = "";

      if (!codigoInput.value.trim()) {
        codigoInput.classList.add("input-error");
        codigoError.textContent = "Digite o código recebido.";
        return false;
      }

      if (!novaSenha || !confirmar) {
        Swal.showValidationMessage("Preencha todos os campos obrigatórios.");
        return false;
      }

      if (novaSenha.length < 8) {
        Swal.showValidationMessage("A senha deve ter no mínimo 8 caracteres.");
        return false;
      }

      if (novaSenha !== confirmar) {
        Swal.showValidationMessage("As senhas não coincidem.");
        return false;
      }

      return {
        email,
        codigo: codigoInput.value.trim(),
        novaSenha
      };
    }
  });
  if (!formValues) return;

  // Loading
  Swal.fire({
    html: `
    <div class="swal-update-container">
      <div class="swal-update-spinner"></div>

      <div class="swal-update-text">
        Atualizando senha...
      </div>
    </div>
  `,
    allowOutsideClick: false,
    allowEscapeKey: false,
    showConfirmButton: false,
    backdrop: "rgba(0,0,0,0.65)",
    customClass: {
      popup: "swal-update-tech"
    }
  });

  try {
    const response = await fetch(`${API_URL}/rnovasenha`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formValues)
    });

    const data = await response.json();

    Swal.close();
    if (response.ok) {
      Swal.fire({
        icon: "success",
        title: "Sucesso",
        text: data.message,
        timer: 3500,
        showConfirmButton: false,
        timerProgressBar: true,
        backdrop: "rgba(0,0,0,0.65)",
        customClass: {
          popup: "swal-update-tech"
        }
      });

    } else {

      // reabre o modal novamente
      redefinirSenha(emailPreenchido);

      setTimeout(() => {
        const codigoInput = document.getElementById("swal-codigo");
        const codigoError = document.getElementById("swal-codigo-error");

        codigoInput.classList.add("input-error");
        codigoError.textContent = data.message || "Código inválido.";
      }, 100);
    }

  } catch (error) {
    Swal.close();
    Swal.fire("Erro", "Servidor indisponível", "error");
  }
}